import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
export interface Props {data :any}
export const ListAdminStrator:React.FC<Props> = ({data}) => {
    const location = useLocation()
    const navigate = useNavigate()
    return(
        <>
        <tbody>
            {data?.map((list:any) => (
            <tr key={list?.ID}>
                <td>
                    <span className="ellipsis">{list?.manager_name}</span>
                </td>
                <td>
                    <span className="ellipsis">{list?.manager_login}</span>
                </td>
                <td>{list?.manager_mobile}</td>
                <td>{list?.manager_phone}</td>
                <td>{list?.manager_email}</td>
                <td onClick={()=>navigate(`${location.pathname}/${list?.ID}`)}>
                    <button></button>
                </td>
            </tr>
            ))}
        </tbody>
        </>
    )
}